import Container from '../../../../elements/Container'
import { useParams } from 'react-router-dom'
import RCTMultiFileConfigure from '../../_components/RCT/RCTMultiFileConfigure'

interface Props {
    prev: () => void
}

const RCTMultiFileConfigurePage: React.FC<Props> = ({ prev }) => {
    const params: any = useParams()

    return (
        <Container size="md">
            <div className="shadow-1 rounded-[0.833rem] p-5" data-testid="multi-file-configure">
                <div className="w-full">
                    <RCTMultiFileConfigure tabledata={{}} literal={params.experiment} onContinue={() => {}} onPrevious={prev} />
                </div>
            </div>
        </Container>
    )
}

export default RCTMultiFileConfigurePage
